// extracted by mini-css-extract-plugin
export default {"root":"themePicker_root__uMRAe","colorItem":"themePicker_colorItem__9CP2a"};